import request from '@/utils/request'
import baseURL from '@/utils/baseURL'
// 物品详情
export function get_goods_datail(query) {
  return request({
    url: baseURL['goods'] + '/v2/goods/detail',
    method: 'get',
    params: query,
    // data
  })
}
export function get_purchase_options(query) {
  return request({
    url: baseURL['goods'] + '/v2/goods/purchase_options',
    method: 'get',
    params: query,
    // data
  })
}
// 检查白名单状态
export function check_wallet_status(query) {
  return request({
    url: baseURL['goods'] + '/v2/goods/check_wallet_status',
    method: 'get',
    params: query,
    // data
  })
} 

// 检查id白名单状态
export function check_pass_status(query) {
  return request({
    url: baseURL['goods'] + '/v2/goods/check_pass_status',
    method: 'get',
    params: query,
    // data
  })
} 

// 抽奖信息
export function peking_monsters_raffle_info() {
  return request({
    url: baseURL['goods'] + '/v2/peking_monsters_raffle/info',
    method: 'get',
    // data
  })
} 

// 查询钱包地址
export function questionnaire_detail() {
  return request({
    url: baseURL['goods'] + '/v2/foundo_questionnaire/detail',
    method: 'get',
    // data
  })
} 

// 创建问卷
export function invite_code_create(data) {
  return request({
    url: baseURL['goods'] + '/v2/foundo_questionnaire/create',
    method: "post",
    data,
  })
} 

// 重新绑定邀请码
export function rebind_invite_code(data) {
  return request({
    url: baseURL['goods'] + '/v2/foundo_questionnaire/rebind_invite_code',
    method: "post",
    data,
  })
} 

// 提交问卷
export function submit_questionnaire(data) {
  return request({
    url: baseURL['goods'] + '/v2/foundo_questionnaire/submit_questionnaire',
    method: "post",
    data,
  })
} 